import { render, staticRenderFns } from "./EnviosAutomaticos.vue?vue&type=template&id=ae0c3492"
import script from "./EnviosAutomaticos.vue?vue&type=script&lang=ts"
export * from "./EnviosAutomaticos.vue?vue&type=script&lang=ts"
import style0 from "./EnviosAutomaticos.vue?vue&type=style&index=0&id=ae0c3492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports